import jQuery from "jquery";
(function ($) {
    let scrollTimeout;

    $(window).on("scroll", function () {
        $(".scroll-to-top").addClass("hidden");
        
		clearTimeout(scrollTimeout);

        scrollTimeout = setTimeout(function () {
            $(".scroll-to-top").removeClass("hidden");
        }, 150);
    });
})(jQuery);
